 
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import Testimonials from "../../home/common/Testimonials";
import LogoSection from "../../home/common/LogoSection";

const TestimonialContainer = () => {
  return (
    <>
      <Breadcrumbs title="Testimonial" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section" />
      <Testimonials type="testimonials" />
      <LogoSection type="testimonial_logo" title="Trusted by leading brands from around the world" />
    </>
  );
};

export default TestimonialContainer;
